import { LiteralUnion } from 'models';

import { API_URL } from 'config';
import { makeAPICall } from './api';

import {
    Satellite,
    mapAPIToSatellite,
    API as SatelliteAPI,
} from './satellites';
import { TLE, mapAPIToTLE, API as TLEAPI } from './tles';

export type Status = LiteralUnion<'valid' | 'invalid' | 'outdated'>;

export declare namespace API {
    export interface Orbit {
        id: number;
        satellite?: SatelliteAPI.Satellite;
        tle?: TLEAPI.TLE;
        status: Status;
        valid_till: string;
        czml: string;
        created: string;
    }
}

export interface Orbit {
    id: number;
    satellite?: Satellite;
    tle?: TLE;
    status: Status;
    valid_till: Date;
    czml: string;
    created: Date;
}

const ORBITS_ROUTE = '/orbits';

export const mapAPIToOrbit = ({
    valid_till,
    created,
    satellite,
    tle,
    ...rest
}: API.Orbit): Orbit => ({
    ...rest,
    satellite: satellite ? mapAPIToSatellite(satellite) : undefined,
    tle: tle ? mapAPIToTLE(tle) : undefined,
    valid_till: new Date(valid_till),
    created: new Date(created),
});

export const listOrbits = makeAPICall<Orbit[], void, { results: API.Orbit[] }>(
    () => ({
        url: `${API_URL}${ORBITS_ROUTE}/`,
    }),
    (data) => data.results.map(mapAPIToOrbit),
);

export const getOrbitById = makeAPICall<Orbit, { id: number }, API.Orbit>(
    ({ id }) => ({
        url: `${API_URL}${ORBITS_ROUTE}/${id}/`,
    }),
    (orbit) => mapAPIToOrbit(orbit),
);

export const getOrbitCZML = makeAPICall<any, { id: number }, any>(
    ({ id }) => ({
        url: `${API_URL}${ORBITS_ROUTE}/${id}/czml.json`,
    }),
    (data) => data,
);
